module.exports = __webpack_public_path__ + "img/ur3_03.f2afa9cb.jpg";